// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#app .section.form-column[data-v-48e9f14b] {\n  width: auto;\n}\n.el-form-item-group fieldset[data-v-48e9f14b] {\n  min-height: 750px;\n  width: 350px;\n}\n.checkbox[data-v-48e9f14b] {\n  margin-right: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
